import {
  AfterContentInit,
  Component,
  ElementRef,
  Inject,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
  TemplateRef,
  viewChild,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, filter, Subject, Subscription, takeUntil } from 'rxjs';
import { AppState } from 'src/app/shareModule/states/app.state';
import { Location } from '@angular/common';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
// import { SelectForumModalComponent } from 'src/app/select-forum-modal/select-forum-modal.component';

declare const google: any;
@Component({
  selector: 'app-marketplace-product',
  templateUrl: './marketplace-product.component.html',
  styleUrls: [
    './marketplace-product.component.scss',
    '../marketplace.component.scss',
  ],
})
export class MarketplaceProductComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('AddShop', { static: false })
  addProductComponent: AddProductComponent | null = null;

  constructor(
    private roleService: RoleService,
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private renderer2: Renderer2,
    private seoService: SeoService,
    private location: Location,
    private sharedService: SharedService,
    private commonService: CommonService,
    @Inject(DOCUMENT) private _document: Document,
    @Inject('WINDOW') private window: any
  ) {
    this.screenWidth = this.window.innerWidth;


    const navigation = this.router.getCurrentNavigation();
    this.passedProductData = navigation?.extras?.state?.passedProductData;
    this.similarProducts = navigation?.extras?.state?.similarProducts ?? [];
    console.log("BUILD FOR PRODUCT DETAIL")

  }
  //this is used to ge
  private passedProductData = null;


  private modalRef: any;
  isLogin: any = 0;
  isLoading: boolean = true;
  appUserId: any;

  public screenWidth: any = 0;
  public imgUrl = environment.ImageUrl;
  public productData: any = null;
  public tabsRecommend: any = [];
  food_icon_1: any;
  food_icon_2: any;
  food_icon_3: any;
  food_icon_4: any;
  food_description: string;
  public enableMemberShop: Boolean = true;
  public prevProduct: any = null;

  public maps: any = {};
  lat: number = 1.3521;
  lng: number = 103.8198;
  map: any;
  geocoder: any;
  marker: any;
  postalCode: string = '';

  paramProduct: string;

  ////////////////////////////// code related to forums on product /////////////////
  public forumCarouselConfig = {
    autoHeight: true,
    slidesPerView: 1,
    navigation: false,
    //spaceBetween: 10,
    initialSlide: 0,
  }



  public isUserAnAdmin = false;
  public productForums = []

  public productSubTypes = new Set();
  public openForum(forum) {
    window.open(window.location.origin + '/forum/' + forum.slug, '_blank')
  }
  public handleSubTypeAssignment(event, subType) {
    let subs;
    const target = event.target;
    if (target.checked) {
      subs = this.auth.addTypeToProduct(this.productData?.id, subType.id, true);
    } else {
      subs = this.auth.removeTypeFromProduct(this.productData?.id, subType.id, true);
    }
    subs.pipe(takeUntil(this.destroy$)).subscribe({
      next: () => this.toastr.success('Changed'),
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong while changed');
      },
    });

  }

  private _fetchForumReplies(forum) {
    console.log({ forum })
    this.auth.marketplace_forum_shop_fetch_reply(forum?.forumId, 1, true, false, 3)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          console.log({ data })
          forum.replies = data.body
        }
      })
  }

  public repliesHolders = []

  public addPostToForum(forum, i) {
    if (!this.repliesHolders[i]) {
      return;
    }
    const form = {
      forumId: forum.forumId,
      message: this.repliesHolders[i],
      createdBy: this.appUserId,
      // id: id,
      // isChild: isChild,
      // parentChild: parentChild,
    };


    try {
      this.auth.marketplace_forum_shop_store_reply(form)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.loadForums();
          },
          error: err => {
            console.error(err);
            this.toastr.error("Something went wrong while posting response")
          }
        });
    } catch (e) {
      console.error(e)
    }
  }

  public loadForums() {
    this.auth.getPagesLinkToForums('product', this.productData?.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: data => {
            // for(const selected of data.body){
            //   this.linkedForum.add(selected.forumId)
            // }
            //console.log(data.body)
            if (Array.isArray(data.body)) {
              this.productForums = structuredClone(data.body);
              for (const forum of this.productForums) {
                this._fetchForumReplies(forum)
              }
              this.repliesHolders = new Array(data.body.length);
              this.repliesHolders.fill('');

            }


          },
          error: console.error
        }
      )

  }
  // public openForumAdd() {
  //   if (!this.isUserAnAdmin) {
  //     return;
  //   }
  //   const modalRef = this.modalService.open(SelectForumModalComponent, { size: 'sm', centered: true })
  //   modalRef.componentInstance.type = 'product'; //this need to be first from product id or whatever params so that the function can decide
  //   modalRef.componentInstance.productId = this.productData?.id;

  //   modalRef.hidden.subscribe(() => {
  //     this.loadForums();
  //   })

  // }

  /////////////////////////////code related to types/////////////////////////
  public typesExist = true;
  public faqsExist = true;

  public get isOnMobile() {
    if (this.sharedService.isBrowser()) {
      return this.window.innerWidth <= 767;
    }
    return 0;
  }
  public carOptions = {
    autoHeight: false,
    slidesPerView: 1,
    //spaceBetween: 10,
    initialSlide: 1,
  };
  initSwiper(e: any) {
    console.log(e, 'swiper');
    // setTimeout(()=>{e.slideTo(1, 0); },1000)
  }

  public realignSwiperIndexWhenTabsChange() {
    if (!this.typesExist) {
      this.carOptions.initialSlide = 0;
    }
    this.carOptions = { ...this.carOptions }
  }


  /////////////////////////code realted to faqs///////////////////////////////
  public userPhoneNumber = '';
  public showLoginWizard = true;

  public openLoginModal() {
    this.commonService.clickButton('loginBtn');
  }
  public editCurrentProduct() {
    this.sharedService.editProductIdSubject.next(this.productData?.id)
  }
  public similarProducts = []
  public _roleSubscription: Subscription | null = null;
  ngOnInit() {
    this.productData =
      this.route.snapshot.data['MarketplaceProductResolver']?.body || null;
    if (this.productData) {
      this._setViewProductModalData({}, this.productData);
      this.loadForums();
      // this._fetchProductSubCategoryFAQInfos();
      // this._fetchTypesOfProduct();
    } else {
      // console.log('productData is not set initially')
    }
    if (this.sharedService.isBrowser()) {
      this.local.getUserDetailsObserver().pipe(takeUntil(this.destroy$)).subscribe((user) => {
        if (user?.id) {
          this.userPhoneNumber = this.local.getUser()?.phoneNumber;
          this.appUserId = user.id;
          this.isLogin = 1;
          this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
            this.isUserAnAdmin = this.roleService?.roles?.userType.includes('ADMIN')
          })
          //once these are readded to dom tree they will reset their values again using events
          this.typesExist = true; //
          this.faqsExist = true
        } else {
          this.isLogin = 0;
        }
      });

    }

    this.sharedService.SingleProductService$.subscribe((data) => {
      this.initProduct();
    });

    this.checkIfLogin();
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((param) => {
        // this.skipPopupOpen = false;
        this.paramProduct = param['product'];
        if (!this.productData) this.initProduct();
      });
  }

  ngOnDestroy(): void {
    console.log("[Start Destroy] Marketplace Product Component")
    this._roleSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    console.log("[End Destroy] Marketplace Product Component")
  }

  checkIfLogin() {
    this.local.getUserDetailsObserver().subscribe(async (user: any) => {
      if (user?.id) {
        this.isLogin = 1;
        this.appUserId = user.id;
      } else {
        this.isLogin = 0;
      }
    });
  }

  public isReferalView = false;
  public linkRfererUserId = null;

  private initProduct() {
    this.isLoading = true;
    if (this.paramProduct) {
      this.enableMemberShop = !this.paramProduct.includes('-biz-');

      if (this.enableMemberShop) {

        //if promo link we need to modiy the url
        if (this.paramProduct.includes('&promo=1')) {
          const lastHypenIndex = this.paramProduct.lastIndexOf('-');
          const markIndex = this.paramProduct.indexOf('&promo=1');
          this.linkRfererUserId = this.paramProduct.substring(
            lastHypenIndex + 1,
            markIndex
          );

          this.paramProduct = this.paramProduct.substring(
            0,
            lastHypenIndex
          );
          this.isReferalView = true;
        }


        if (this.passedProductData) {
          //popup passed data to page
          console.log('state is passed to page', this.passedProductData);
          this._setViewProductModalData({}, this.passedProductData);
        } else {
          //console.log('state is not passed to page', navigation)
          this.auth
            .getShopProductDetails({ productId: this.paramProduct })
            .pipe(takeUntil(this.destroy$))
            .subscribe(
              (response: any) => {
                this._setViewProductModalData({}, response.body);
                // this._fetchProductSubCategoryFAQInfos();
                // this._fetchTypesOfProduct();
              },
              (e) => {
                this.isLoading = false;
                this.productData = null;
              }
            );
        }

      } else
        this.auth.get_food_details({ foodId: this.paramProduct })
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (response: any) => {
              this._setViewProductModalData({}, response.body);
            },
            (e) => {
              this.isLoading = false;
              this.productData = null;
            }
          );
    }
  }

  private _setViewProductModalData(
    selectedProduct,
    response,
    isSearch = false
  ) {
    this.productData = structuredClone(response);
    this.loadForums();
    this.productData.enableMemberShop = this.enableMemberShop;

    this.productData.shoutContact =
      this.productData.shoutContact?.toString().substr(0, 2) == '65'
        ? this.productData.shoutContact
        : `65${this.productData.shoutContact}`;

    if (this.productData && this.productData?.name) {
      if (
        this.productData?.type == 'rental' &&
        !this.productData.name.includes('- RENTAL')
      ) {
        this.productData.name += ' - RENTAL';
      }
      let foodName = this.productData?.name;
      if (
        this.productData?.seller?.shop_name &&
        this.productData?.seller?.shop_name != 'null'
      ) {
        foodName += ' | ' + this.productData?.seller?.shop_name;
      }
      const companyName = this.productData?.companyName ? ` By ${this.productData?.companyName}` : ''

      this.seoService.update({
        main_title: ' | BEST SERVICES SG',
        title: foodName + companyName,
        description: this.productData.description,
        image: this.imgUrl + this.productData?.primaryImage,
      });
      this.seoService.addMetaTags(this.productData?.metadata)

      this.seoService.removeSchema()
      // this.seoService.initSchema(this.productData)
      this.seoService.initProductSchema({
        ...this.productData,
        name: foodName + companyName,
        description: this.productData.description,
        image: this.imgUrl + this.productData?.primaryImage,
      })

      if (this.productData?.type != 'promote' && this.enableMemberShop) {
        if (!this.productData?.appUser?.noIndexProduct || this.productData.noIndex) {
          this.seoService.updateNoIndex(true);
        }
      }

      if (!this.enableMemberShop && !this.productData.isHighlight) {
        this.seoService.updateNoIndex(true);
      }
      // this.seoService.updateNoIndex(true);
    }
    this.productData['edit_product_id'] = selectedProduct?.id;
    this.productData['enableMemberShop'] = this.enableMemberShop;
    this.productData['prevProduct'] = this.prevProduct;

    try {
      this.productData['selectedHolidays'] = this.productData.holidays
        ? JSON.parse(this.productData.holidays)
        : '';
      this.productData.hiddenBy =
        this.productData.hiddenBy != null
          ? JSON.parse(this.productData.hiddenBy)
          : [];
    } catch (e) { }

    if (response?.body?.sellerInfo || response?.sellerInfo) {
      try {
        this.productData['sellerInformation'] = JSON.parse(
          response?.body?.sellerInfo || response?.sellerInfo
        );
      } catch {
        this.productData['sellerInformation'] = {};
      }
    }

    if (this.productData.icons != null && this.productData.icons != '') {
      const icons = JSON.parse(this.productData.icons);
      this.productData['iconsWithText'] = icons.filter(
        (item: any) => item.text !== ''
      );
      this.productData['iconsWithoutText'] = icons.filter(
        (item: any) => item.text === ''
      );
    }

    this.foodFavoriteStatus(this.productData.id); //check
    const getImageByAccessor = (images = [], accessor) => {
      const imageObj = images.find((o) => o.imageAccessor === accessor);
      return imageObj ? imageObj.image : '';
    };
    if (this.enableMemberShop) {
      this.productData['foodSpecs'] =
        this.productData?.memberShopProductsVariations || [];
      this.productData['food_image_1'] = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'image1'
      );
      this.productData['food_image_active'] = this.productData['food_image_1'];
      this.productData['food_image_2'] = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'image2'
      );
      this.productData['food_image_3'] = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'image3'
      );
      this.productData['food_image_4'] = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'image4'
      );

      this.food_icon_1 = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'icon1'
      );
      this.food_icon_2 = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'icon2'
      );
      this.food_icon_3 = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'icon3'
      );
      this.food_icon_4 = getImageByAccessor(
        this.productData.memberShopProductsImages,
        'icon4'
      );
    } else {
      this.productData['food_image_1'] = getImageByAccessor(
        this.productData.foodImages,
        'image1'
      );
      this.productData['food_image_active'] = this.productData['food_image_1'];
      this.productData['food_image_2'] = getImageByAccessor(
        this.productData.foodImages,
        'image2'
      );
      this.productData['food_image_3'] = getImageByAccessor(
        this.productData.foodImages,
        'image3'
      );
      this.productData['food_image_4'] = getImageByAccessor(
        this.productData.foodImages,
        'image4'
      );

      this.food_icon_1 = getImageByAccessor(
        this.productData.foodImages,
        'icon1'
      );
      this.food_icon_2 = getImageByAccessor(
        this.productData.foodImages,
        'icon2'
      );
      this.food_icon_3 = getImageByAccessor(
        this.productData.foodImages,
        'icon3'
      );
      this.food_icon_4 = getImageByAccessor(
        this.productData.foodImages,
        'icon4'
      );
    }
    this.food_description = this.productData.description;

    //my tabs
    this.productData['tabsInfo'] = [
      {
        title: 'Info',
        icon: 'fa-solid fa-circle-info',
        condition: this.productData.description != '',
      },
      {
        title: 'Detail',
        // icon: 'fa-solid fa-circle-info',
        condition:
          this.productData.charges != '' &&
          this.productData.charges != undefined &&
          this.productData.charges != 'null' &&
          this.productData.charges != '-',
      },
      // {
      //   title: 'Price',
      //   icon: 'fa-solid fa-dollar-sign',
      //   condition:
      //     (this.productData?.memberShopProductsVariations?.length > 0 ||
      //       this.productData?.['foodSpecs']?.length > 0) &&
      //     this.productData?.type != 'promote',
      // },
      {
        title: 'Rent',
        // icon: 'fa-solid fa-circle-info',
        condition:
          this.productData?.type == 'rental' &&
          (this.productData?.depositAmt ||
            this.productData?.estimateValue ||
            this.productData?.warranty),
      },
      {
        title: 'Contact',
        icon: 'fa-solid fa fa-phone',
        condition:
          this.productData?.type == 'promote' &&
          (this.productData?.roleName?.includes('SUPER SELLER') ||
            this.productData?.roleName?.includes('ADMIN')) &&
          (this.nullCheck(this.productData?.shoutContactRelation) ||
            this.nullCheck(this.productData?.shoutWebsite)),
      },
      {
        title: this.productData?.subRegionName?.trim() ?? 'Location',
        icon: 'fa-solid fa-location',
        condition:
          (this.productData?.type == 'promote' &&
            this.productData?.latLong != '{}' &&
            this.productData?.latLong != null) ||
          (this.productData?.type != 'promote' &&
            this.productData?.appUser?.postalCode != null),
      },
    ];

    this.productData['tabs'] = [
      {
        title: 'USP',
        condition: this.productData?.productVerficationsList?.length > 0,
      },
      {
        title: 'More',
        condition: this.productData?.productMoreServices?.length > 0,
      },
      {
        title: 'Profile',
        //  icon: 'fa-solid fa-user'
      },
      {
        title: 'More Products',
        // icon: '',
        condition: this.productData?.more_products_data?.length > 0,
      },
      {
        title: 'Socials',
        // icon: 'fa-solid fa-star',
        condition:
          this.productData['sellerInformation']?.fbReviewUrl ||
          this.productData['sellerInformation']?.carousellReviewUrl ||
          this.productData['sellerInformation']?.googleReviewUrl ||
          this.productData['sellerInformation']?.websiteUrl ||
          this.productData['sellerInformation']?.instagramUrl ||
          this.productData['sellerInformation']?.fbUrl,
      },

      // {
      //   title: 'Holiday',
      //   condition:
      //     this.productData?.selectedHolidays.length > 0 &&
      //     (this.productData?.roleName?.includes('SUPER SELLER') ||
      //       this.productData?.roleName?.includes('ADMIN')),
      // },
    ];

    if (this.sharedService.isBrowser()) {
      this.seoService.initSchema(this.productData);
      this.isLoading = false;
    }

    setTimeout(() => {
      const modalContent = this._document?.getElementsByClassName('modal-body');
      if (modalContent?.length > 0) {
        modalContent[0].scrollTop = 0; // Scroll to the top of the first element with the class 'modal-body'
      }
    }, 100);
  }

  foodFavoriteStatus(foodId: any) {
    let formData = null;
    if (this.enableMemberShop) {
      formData = {
        member_product_id: foodId,
        isAdmin: this.isAdmin(),
      };
    } else {
      formData = {
        foodId: foodId,
        isAdmin: this.isAdmin(),
      };
    }
    this.auth
      .marketplace_favorite_product_status(formData)

      .subscribe((response: any) => {
        this.productData.isFavorite = response.body.status;
      });
  }

  isAdmin = () => this.local.getUser()?.role == 'admin';
  private nullCheck(value: any): string {
    if (value === null || value === 'null' || value === '') {
      return '';
    }
    return value;
  }
  public isArray(input) {
    return Array.isArray(input);
  }

  shopUpdate(data: any) {
    console.log(data);
  }
  public typeList = []
  public setTypeList(list) {
    console.log("setting list to", list)
    this.typeList = list
    this.auth.getTypesOfProduct(this.productData?.id, true).subscribe({
      next: (data: any) => {
        this.productSubTypes = new Set(data.data.map((t) => t.subTypeId));

      },
      error: console.error,
    });

  }


  goBack(): void {
    this.router.navigate(['/category/' + (this.productData?.categorySlug ?? this.productData?.categoryName?.toLowerCase()?.replaceAll(' ', '-'))])
  }


  public searchProds = [];
  @ViewChild('seeProductList')
  public seeProductList: TemplateRef<any>;

  public searchSimilarSubType(subType) {

    this.auth
      .fetchProductsBasedOnTypes({ types: Array.from([subType.id]), isSubType: true })
      .subscribe({
        next: (data: any) => {
          this.searchProds = data.data;
          this.modalService.open(this.seeProductList, { size: 'md' });
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error something went wrong while fetching ');
        },
      });
  }
  public goToProduct(prod) {
    this.window.open('product/' + prod.slug, '_blank');
  }

}
